import React, {FC, useMemo, useState} from 'react'
import {Headers} from '../types'
import {NaturalReferencingBySearchEngine} from '../../../../../app/@types'
import {paginate} from '../../../content/pagination/types'
import CountUp from 'react-countup'
import {Pagination} from '../../../content/pagination/Pagination'

const headers: Headers<NaturalReferencingBySearchEngine>[] = [
  {key: 'socialNetwork', label: 'Moteur de recherche', className: 'fw-bolder text-muted bg-light min-w-200px'},
  {key: 'sessions', label: 'Séances', className: 'fw-bolder text-muted bg-light min-w-200px'},
  {key: 'pageviews', label: 'Pages vues', className: 'fw-bolder text-muted bg-light min-w-200px'},
  {key: 'avgSessionDuration', label: 'Durée moyenne de la session', className: 'fw-bolder text-muted bg-light min-w-200px',},
]

type Props = {
  data: NaturalReferencingBySearchEngine[]
}

const TablesWidget24: FC<Props> = ({data}) => {

  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const paginateData = useMemo(
    () => paginate<NaturalReferencingBySearchEngine>({currentPage, itemsPerPage, data}),
    [currentPage, itemsPerPage, data],
  )

  return (
    <>
      <div className="table-responsive">
        <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">

          <thead>
          <tr>
            {
              headers.map(({key, label, className}, index) => (
                <th key={index} className={`${!index ? 'ps-5' : ''} ${className}`}>{label}</th>
              ))
            }
          </tr>
          </thead>
          <tbody>
          {
            paginateData.map((item, index) => (
              <tr key={index}>
                <td>
                  <div className="d-flex align-items-center">
                    <div className="symbol symbol-50px me-4" />
                    <div className="d-flex justify-content-start flex-column">
                        <span className="text-dark fw-bolder mb-1 fs-7">{item.socialNetwork}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="text-dark fw-bolder d-block mb-1 fs-7">
                      <CountUp end={+item.sessions} duration={.7} />
                  </span>
                </td>
                <td>
                  <span className="text-dark fw-bolder d-block mb-1 fs-7">
                      <CountUp end={+item.pageviews} duration={.7} />
                  </span>
                </td>
                <td>
                  <span className="text-dark fw-bolder d-block mb-1 fs-7">
                      <CountUp end={+item.avgSessionDuration} duration={.7} decimals={2} suffix={'s'} />
                  </span>
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
      </div>
      <Pagination itemsPerPage={itemsPerPage}
                  totalItems={data.length}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
      />
    </>
  )
}

export {TablesWidget24}